import React, {useState} from "react";
import Tools from "../../../../../Tools";
import arsenal from "../../../../../assets/svg/auth/team/arsenal.svg";
import {Col, Container, Form, Row} from "react-bootstrap";
import SelectButtonsList from "../../../../ui/select/SelectButtonsList";
import InputSearch from "../../../../ui/forms/InputSearch";
import MainButton from "../../../../ui/forms/Buttons";

const SelectClubAgencyStep = props => {
    /**
     * Constants values.
     * @type {string}
     */
    const backText = 'Back';
    const nextText = 'Next';
    const formHeaderText = 'Please Select Your Club/Agency';
    const searchPlaceHolder = 'Search Club or Agency';

    const {loading, error, data} = props;
    const {professionValue, value} = props;
    const {onSelect: onSelectedValueChange, onBackClick, onNextClick} = props;

    const [searchText, setSearchText] = useState('');

    const onSearchChange = (event) => setSearchText(Tools.eventValue(event));

    const fillOptions = (data, professionValue, searchText) => {
        if (!data || !professionValue) return [];

        const loadTeams = Tools.findInArray(['coach', 'clubManager', 'player', 'scout'], professionValue);
        const loadAgencies = Tools.findInArray(['playerAgent', 'scout'], professionValue);

        let result = [];
        const {teams, agencies} = data;

        if (loadTeams)
            result = [...result, ...teams];

        if (loadAgencies)
            result = [...result, ...agencies];

        return result.filter(item => Tools.find(item.name, searchText)).map(team => ({value: team.id, label: team.name, svg: arsenal}));
    };

    const options = fillOptions(data, professionValue, searchText);

    if (error) return `Errors: ${error}`;

    return (

        <Form className="select-club-agency-step sign-up-form">
            <Form.Group>
                <Form.Text className="form--header"> {formHeaderText} </Form.Text>
                <InputSearch size="xl" color="primary" placeHolder={searchPlaceHolder} onChange={onSearchChange}/>
                <SelectButtonsList options={options} loading={loading} defaultValue={value} onChange={(value) => onSelectedValueChange(value)}/>

                <Container fluid>
                    <Row className="form--row">
                        <Col lg={6} xs={12} className="form--col">
                            <MainButton color="secondary" size="xl" text={backText} className="w-100" onClick={onBackClick}/>
                        </Col>

                        <Col lg={6} xs={12} className="form--col">
                            <MainButton color="primary" size="xl" text={nextText} className="w-100" disabled={value === undefined} onClick={onNextClick}/>
                        </Col>
                    </Row>
                </Container>
            </Form.Group>
        </Form>
    );
};
export default SelectClubAgencyStep;
